export const SUCESS_STATUS = [200, 201, 202, 203];
export const PUBLIC_ROUTES = ['signin'];
